import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';
import { KeretService } from '../keret.service';

/**
 *  ÜGYFÉLPORTÁL – a könyvelt cég olvassa a saját könyvelését és bérszámfejtését (backend/ugyfelportal.js).
 *
 *  Forrás: a felhasználóhoz kötött cégek ezen az installáción (a könyvelő adta a hozzáférést), vagy a
 *  kapcsolati kóddal elért könyvelés egy másik installációról. Csak olvasás.
 */
@Component({
  selector: 'app-ugyfelportal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ugyfelportal.component.html',
  styleUrls: ['./ugyfelportal.component.scss'],
})
export class UgyfelportalComponent implements OnInit {
  forrasok: any[] = [];
  forras: any = null;
  ev = new Date().getFullYear();
  evek = [0, 1, 2, 3].map((d) => new Date().getFullYear() - d);
  ful: 'attekintes' | 'bevallasok' | 'ber' = 'attekintes';
  a: any = null; b: any = null; ber: any = null;
  betolt = true; fut = false; hiba = '';
  kod = ''; url = ''; kezi = false; kodHiba = '';
  readonly honapok = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];

  constructor(private http: HttpClient, private data: DataService, public router: Router, private keret: KeretService) {}

  async csatlakozik() {
    this.fut = true; this.kodHiba = '';
    try {
      const r: any = await firstValueFrom(this.http.post('/api/ugyfelportal/csatlakozas', { kod: this.kod.trim(), url: this.kezi ? this.url.trim() : '', intezmeny: this.keret.a?.intezmenyId() }));
      try { localStorage.setItem('ugyfelportalForras', r.kulcs); } catch { /* */ }
      this.kod = ''; this.url = '';
      await this.ngOnInit();
    } catch (e: any) { this.kodHiba = e?.error?.error || 'A kapcsolódás nem sikerült.'; }
    this.fut = false;
  }

  async ngOnInit() {
    try {
      const r: any = await firstValueFrom(this.http.get('/api/ugyfelportal/forrasok'));
      this.forrasok = [...(r.helyi || []), ...(r.tavoli || [])];
      let mentett = ''; try { mentett = localStorage.getItem('ugyfelportalForras') || ''; } catch { /* privát ablak */ }
      this.forras = this.forrasok.find((f) => f.kulcs === mentett) || this.forrasok[0] || null;
    } catch (e: any) { this.hiba = e?.error?.error || 'Nem sikerült betölteni.'; }
    this.betolt = false;
    if (this.forras) await this.frissit();
  }

  van(h: string) { return !!this.forras?.hatokorok?.includes(h); }
  async valt(f: any) { this.forras = f; try { localStorage.setItem('ugyfelportalForras', f.kulcs); } catch { /* */ } await this.frissit(); }
  async fulValt(f: any) { this.ful = f; await this.frissit(); }

  async frissit() {
    if (!this.forras) return;
    this.fut = true; this.hiba = '';
    const alap = `/api/ugyfelportal/${encodeURIComponent(this.forras.kulcs)}`;
    try {
      if (this.ful === 'attekintes') this.a = await firstValueFrom(this.http.get(`${alap}/attekintes`, { params: { ev: this.ev } }));
      if (this.ful === 'bevallasok') this.b = await firstValueFrom(this.http.get(`${alap}/bevallasok`, { params: { ev: this.ev } }));
      if (this.ful === 'ber') this.ber = await firstValueFrom(this.http.get(`${alap}/ber`, { params: { ev: this.ev } }));
    } catch (e: any) { this.hiba = e?.error?.error || 'Nem sikerült lekérni.'; }
    this.fut = false;
  }
  pdf(r: any) { this.data.megnyitFajl(`/api/ugyfelportal/${encodeURIComponent(this.forras.kulcs)}/bevallas-pdf/${encodeURIComponent(r.iktato)}`, `${r.kod} ${r.idoszak || ''}`); }
  osszeg(l: any[], m: string) { return (l || []).reduce((s, x) => s + (Number(x[m]) || 0), 0); }
  modNev(m: string) { return m === 'kettos' ? 'kettős könyvvitel' : 'egyszeres könyvvitel'; }
}
